import React from 'react';

interface AnimatedBackgroundProps {
  className?: string;
  variant?: 'gradient' | 'mesh' | 'dots' | 'grid';
}

export const AnimatedBackground: React.FC<AnimatedBackgroundProps> = ({ 
  className = '', 
  variant = 'gradient' 
}) => {
  if (variant === 'mesh') {
    return (
      <div className={`absolute inset-0 overflow-hidden ${className}`}>
        <div className="absolute inset-0">
          <div className="absolute top-0 -left-4 w-72 h-72 bg-optibiz-blue/30 rounded-full mix-blend-multiply filter blur-3xl animate-blob dark:opacity-20"></div>
          <div className="absolute top-0 -right-4 w-72 h-72 bg-optibiz-orange/30 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000 dark:opacity-20"></div>
          <div className="absolute -bottom-8 left-20 w-72 h-72 bg-optibiz-green/30 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-4000 dark:opacity-20"></div>
          <div className="absolute -bottom-8 right-20 w-72 h-72 bg-optibiz-yellow/30 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-6000 dark:opacity-20"></div>
        </div>
      </div>
    );
  }

  if (variant === 'dots') {
    return (
      <div className={`absolute inset-0 ${className}`}>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-bg-opacity)_1px,_transparent_1px)] bg-[length:40px_40px] bg-optibiz-blue/10 dark:bg-optibiz-blue/5 opacity-50"></div>
      </div>
    );
  }

  if (variant === 'grid') {
    return (
      <div className={`absolute inset-0 ${className}`}>
        <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="0.5" className="text-optibiz-blue/10 dark:text-optibiz-blue/5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>
    );
  }

  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`}>
      <div className="absolute inset-0 bg-gradient-to-br from-optibiz-blue/20 via-transparent to-optibiz-orange/20 dark:from-optibiz-blue/10 dark:to-optibiz-orange/10 animate-gradient"></div>
    </div>
  );
};

export default AnimatedBackground;
